// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFileAggregatorResponseDto } from './IFileAggregatorResponseDto';
import {
    IFileAggregatorResponseDtoFromJSON,
    IFileAggregatorResponseDtoFromJSONTyped,
    IFileAggregatorResponseDtoToJSON,
    IFileAggregatorResponseDtoToJSONTyped,
} from './IFileAggregatorResponseDto';
import type { IRecordsDetailsDto } from './IRecordsDetailsDto';
import {
    IRecordsDetailsDtoFromJSON,
    IRecordsDetailsDtoFromJSONTyped,
    IRecordsDetailsDtoToJSON,
    IRecordsDetailsDtoToJSONTyped,
} from './IRecordsDetailsDto';

/**
 * 
 * @export
 * @interface IFileDetailsAggregatorResponseDto
 */
export interface IFileDetailsAggregatorResponseDto {
    /**
     * 
     * @type {IFileAggregatorResponseDto}
     * @memberof IFileDetailsAggregatorResponseDto
     */
    file_aggregator_dto_response?: IFileAggregatorResponseDto;
    /**
     * 
     * @type {IRecordsDetailsDto}
     * @memberof IFileDetailsAggregatorResponseDto
     */
    records_details_dto?: IRecordsDetailsDto;
}

/**
 * Check if a given object implements the IFileDetailsAggregatorResponseDto interface.
 */
export function instanceOfIFileDetailsAggregatorResponseDto(value: object): value is IFileDetailsAggregatorResponseDto {
    return true;
}

export function IFileDetailsAggregatorResponseDtoFromJSON(json: any): IFileDetailsAggregatorResponseDto {
    return IFileDetailsAggregatorResponseDtoFromJSONTyped(json, false);
}

export function IFileDetailsAggregatorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileDetailsAggregatorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_aggregator_dto_response': json['file_aggregator_dto_response'] == null ? undefined : IFileAggregatorResponseDtoFromJSON(json['file_aggregator_dto_response']),
        'records_details_dto': json['records_details_dto'] == null ? undefined : IRecordsDetailsDtoFromJSON(json['records_details_dto']),
    };
}

export function IFileDetailsAggregatorResponseDtoToJSON(json: any): IFileDetailsAggregatorResponseDto {
    return IFileDetailsAggregatorResponseDtoToJSONTyped(json, false);
}

export function IFileDetailsAggregatorResponseDtoToJSONTyped(value?: IFileDetailsAggregatorResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_aggregator_dto_response': IFileAggregatorResponseDtoToJSON(value['file_aggregator_dto_response']),
        'records_details_dto': IRecordsDetailsDtoToJSON(value['records_details_dto']),
    };
}

